import React from 'react'

function Svg4(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={24}
      height={24}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#4_svg__clip0)" stroke="currentColor">
        <rect x={3} y={6} width={18} height={14} rx={1} />
        <path d="M11 13H4a1 1 0 01-1-1V7a1 1 0 011-1h16a1 1 0 011 1v5a1 1 0 01-1 1h-7" />
        <rect x={11.15} y={12.152} width={1.7} height={2.963} rx={0.85} />
        <path d="M11.25 14h1.5M13.64 5.999v-.812a1 1 0 00-1-1h-1.28a1 1 0 00-1 1v.812" />
      </g>
      <defs>
        <clipPath id="4_svg__clip0">
          <path fill="#fff" d="M0 0h24v24H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default Svg4
